define(
    'viewmodels/secured/explorer/details/tabs/actions/DeleteAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "viewmodels/secured/explorer/details/documentClipboard",
        "services/config",
        "services/eventbroker",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, documentClipboard, config, eventBroker, dialogService, documentsService, i19n) {
        var DeleteAction = (function (_super) {
            var _i19n = {
                action: {
                    name: i19n.to.delete,
                    message: i19n.to.markdocumentsasdeleted + "."
                }
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-trash-o", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();

                documentsService
                .actions
                .canDelete(documents)
                .done(function (result) {
                    var promise;                    

                    if (!result.success) {
                        promise = dialogService.showDocumentActionErrorDialog(result);
                    } else {
                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionDeleteModal",'');

                        promise.then(function (dialogResult) {
                            if (dialogResult.deleting) {
                                //_.map(documents, function (itm) {
                                //    eventBroker.trigger(this, config.events.explorer.results.kendoGridRowMarkDirty, { docId: itm.docId });
                                //});

                                documentsService
                                .actions
                                .deleteDocuments(documentClipboard.toDocumentLocationList(documents))
                                .done(function () {
                                })
                                .fail(function (e) {
                                    e.stopPropagation = true;

                                    self.errors(e.error);

                                    console.warn(e);
                                })
                                .always(function () {
                                    require(["viewmodels/secured/explorer/navigation/menu"], function (menu) {
                                        if (menu.currentItem().id == 'library') {
                                            if (!(!ctx.current || !ctx.current.folder)) {
                                                ctx.onReloadFolders({ isUpdateNodeOnly: true, folderId: ctx.current.folder.folderId, _updateNode: { docCount: ctx.current.folder.docCount - documents.length, text: ctx.current.folder.name() } });
                                            }
                                        } else {
                                            //ctx.onDocument(null); //this is perform in filterBy
                                        }

                                        eventBroker.trigger(this, config.events.explorer.results.filterby, { type: 'refresh' });
                                    });                                    

                                    complete();
                                });
                            } else {
                                complete();
                            }
                        });
                    }

                    promise.then(complete);
                });
            }

            return _Action;

        })(Action);

        return DeleteAction;
    });
